import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@store";

export const TRIGGER_GET_CONCIERGE_SERVICE = "TRIGGER_GET_CONCIERGE_SERVICE";

interface ConciergeServiceInterface {
  data: any;
  loading: boolean;
  error: Record<string, string | number | object> | null;
}

const initialState: ConciergeServiceInterface = {
  data: [],
  loading: false,
  error: {},
};

export const getConciergeServiceSlice = createSlice({
  name: "getConciergeService",
  initialState,
  reducers: {
    fetchConciergeServiceStart: (state) => {
      state.loading = true;
      state.error = {};
    },
    fetchConciergeServiceSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchConciergeServiceFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetConciergeServiceState: () => initialState,
  },
});

export const {
  resetConciergeServiceState,
  fetchConciergeServiceStart,
  fetchConciergeServiceSuccess,
  fetchConciergeServiceFailure,
} = getConciergeServiceSlice.actions;

export const getConciergeServiceSliceList = (state: RootState) => state.conciergeServiceSliceList;

export default getConciergeServiceSlice.reducer;
